module.exports = __webpack_public_path__ + "img/16.430731e1.jpg";